/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';

import { AppContext } from './AppContext'

class MainMenu extends React.Component
{
  constructor(props) 
  {
    super();
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.toggleHelpDropdown = this.toggleHelpDropdown.bind(this);
    this.toggleAdminDropdown = this.toggleAdminDropdown.bind(this);
    this.toggleUserDropdown = this.toggleUserDropdown.bind(this);
    this.closeHelpDropdown = this.closeHelpDropdown.bind(this);
    this.closeAdminDropdown = this.closeAdminDropdown.bind(this);
    this.closeUserDropdown = this.closeUserDropdown.bind(this);

    this.state = 
    {
      navbarIsOpen: false,
      helpDropdownOpen: false,
      adminDropdownOpen: false,
      userDropdownOpen: false
    };
  }

  toggleNavbar() 
  {
    this.setState(
    {
      navbarIsOpen: !this.state.navbarIsOpen
    });
  }

  toggleHelpDropdown() 
  {
    this.setState(
    {
      helpDropdownOpen: !this.state.helpDropdownOpen
    });
  }

  toggleAdminDropdown() 
  {
    this.setState(
    {
      adminDropdownOpen: !this.state.adminDropdownOpen
    });
  }

  toggleUserDropdown() 
  {
    this.setState(
    {
      userDropdownOpen: !this.state.userDropdownOpen
    });
  }

  closeHelpDropdown() 
  {
    this.toggleHelpDropdown();
    if (!this.state.navbarIsOpen) this.toggleNavbar();
  }

  closeAdminDropdown() 
  {
    this.toggleAdminDropdown();
    if (!this.state.navbarIsOpen) this.toggleNavbar();
  }

  closeUserDropdown() 
  {
    this.toggleUserDropdown();
    if (!this.state.navbarIsOpen) this.toggleNavbar();
  }
  
  closeUserDropdownAndSignOut(event) 
  {
    event.preventDefault();
    this.toggleUserDropdown();

    if (!this.state.navbarIsOpen) this.toggleNavbar();

    this.context.signout();
  }

  renderActiveSessionMenu()
  {
    let appContext = this.context;

    return(
      <div className="justify-content-between" style={{display: 'flex', width: '100%'}}>
        <NavbarToggler  onClick={this.toggleNavbar} />
        <Collapse isOpen={this.state.navbarIsOpen} navbar>
          <Nav navbar>
            <NavItem >
              <NavLink to="vaultView" className="nav-link">Objects</NavLink>
            </NavItem>
            <NavItem >
              <NavLink to="keywords" className="nav-link">Keywords</NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="pathParser" className="nav-link">Path Parser</NavLink>
            </NavItem>
            { this.renderAdministratorMenu() }
            <Dropdown nav isOpen={this.state.helpDropdownOpen} toggle={this.toggleHelpDropdown}>
              <DropdownToggle nav caret >
                Help
              </DropdownToggle>
            { undefined !== appContext.websiteProfile &&
              <DropdownMenu>
                <a className="dropdown-item" target="_blank" rel="noopener noreferrer" 
                  href={appContext.websiteProfile.documentationLink} onClick={this.toggleHelpDropdown}>Documentation
                </a>
                <Link to="supportInfo" className="dropdown-item" onClick={this.toggleHelpDropdown}>Support Info</Link>
              </DropdownMenu>
            }
            </Dropdown>
          </Nav>
          <Nav className='ms-auto' navbar>
            <Dropdown nav isOpen={this.state.userDropdownOpen} toggle={this.toggleUserDropdown}>
              <DropdownToggle nav caret>
                {this.context.userSession.sessionInfo.firstName + ' ' +  this.context.userSession.sessionInfo.lastName}
              </DropdownToggle>
              <DropdownMenu>
                <Link className="dropdown-item" onClick={this.toggleUserDropdown} to="manageProfile">Manage Profile</Link>
                <Link className="dropdown-item" onClick={this.toggleUserDropdown} to="userStreamingHistory">Streaming History</Link>
                <Link className="dropdown-item" onClick={this.toggleUserDropdown} to="userGatewayHistory">Gateway History</Link>
                <Link to="home" className="dropdown-item" onClick={(e) => this.closeUserDropdownAndSignOut(e)}>Signout</Link>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </Collapse>
      </div>
    );
  }

  renderAdministratorMenu()
  {
    if (this.context.userSession.isAdministrator())
      return (
        <Dropdown nav isOpen={this.state.adminDropdownOpen} toggle={this.toggleAdminDropdown}>
          <DropdownToggle nav caret>
            Admin
          </DropdownToggle>
          <DropdownMenu>
              <Link className="dropdown-item" onClick={this.toggleAdminDropdown} to="websiteAdmin">Website Admin</Link> 
              <Link className="dropdown-item" onClick={this.toggleAdminDropdown} to="objectTypes">Object Types</Link>
              <Link className="dropdown-item" onClick={this.toggleAdminDropdown} to="userAdmin">User Admin</Link>
              <Link className="dropdown-item" onClick={this.toggleAdminDropdown} to="emailControlPanel">Email Admin</Link>
              <Link className="dropdown-item" onClick={this.toggleAdminDropdown} to="apiErrorLog">API Error Log</Link>
          </DropdownMenu>
        </Dropdown>
      );
    else
      return null;
  }

  renderBlockedSessionMenu()
  {
    return (
      <div className="justify-content-between" style={{display: 'flex', width: '100%'}}>
        <NavbarToggler onClick={this.toggleNavbar} />
        <NavbarBrand href="home"><img alt='AsterionDB' width={20} src='assets/images/icon150x150.png' /> AsterionDB</NavbarBrand>
        <Nav className="mr-auto" navbar>
          <NavItem>
        {/* This is not react-router compatible, so we just grab the class it applies and use that below: <NavLink href="/login">Login</NavLink> */}
        {/* NOTE/TODO: see notes up above - currently this is redundant because we only have one page available in non-authorized state, which is 
            the login page */}
            {/* <Link className="nav-link" to="/login">Login</Link> */}
          </NavItem>
        </Nav>
        <Nav navbar>
          <Dropdown nav isOpen={this.state.userDropdownOpen} toggle={this.toggleUserDropdown}>
            <DropdownToggle nav caret>
              { this.context.userSession.sessionInfo.firstName + ' ' +  this.context.userSession.sessionInfo.lastName }
            </DropdownToggle>
            <DropdownMenu end>
              <Link to="home" className="dropdown-item" onClick={(e) => this.closeUserDropdownAndSignOut(e)}>Signout</Link>
            </DropdownMenu>
          </Dropdown>
        </Nav> 
      </div>
    );
  }

  renderNoSessionMenu()
  {
    return (
      <div>
        <NavbarBrand href="home"><img alt='AsterionDB' width={20} src='assets/images/icon150x150.png' /> AsterionDB</NavbarBrand>
        <Nav className="mr-auto" navbar>
          <NavItem>
            {/* This is not react-router compatible, so we just grab the class it applies and use that below: <NavLink href="/login">Login</NavLink> */}
            {/* NOTE/TODO: see notes up above - currently this is redundant because we only have one page available in non-authorized state, 
                which is the login page */}
            {/* <Link className="nav-link" to="/login">Login</Link> */}
          </NavItem>
        </Nav>
      </div>
    );
  }

  render()
  {
    let menuBody = null;

    switch (this.props.sessionStatus)
    {
      case 'active':
        menuBody = this.renderActiveSessionMenu();
        break;

      case 'session limit':
      case 'change password':
      case 'auth code':
        menuBody = this.renderBlockedSessionMenu();
        break;

      default:
        menuBody = this.renderNoSessionMenu();
        break;
    }

    return(
      <div>
        <Navbar className='bg-primary' dark fixed="top" expand="md" >
          {menuBody}
        </Navbar>
      </div>
    )
  }
}

MainMenu.contextType = AppContext;

export default MainMenu